const bulletedList = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return <ul {...attributes}>{children}</ul>;
    },
    PreviewElement: ({ attributes, children }) => {
        return <ul {...attributes}>{children}</ul>;
    },
};

export default bulletedList;
